import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import LottiePlayer from "lottie-react";
import NoDataFound from '../../../uno/assets/img/nodatafound.json';


const GroupCard = ({ search }) => {

  const [data, setData] = useState([]);
  const { groupId } = useParams();
  const userData = useSelector((state) => state.userSlice);
  const token = userData.token;
  const configData = useSelector((state) => state.configSlice);
  const apiBaseUrl = configData.config.ssoUrl;

  useEffect(() => {
    const fetchGroupsData = async () => {
      try {
        const customHeaders = {
          Authorization: `Bearer ${token}`,
        };

        const response = await axios.get(`${apiBaseUrl}/api/user/group/list/${groupId}`, {
          headers: customHeaders,
        });

        setData(response?.data?.data)
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchGroupsData();
  }, [groupId, apiBaseUrl, token]);

  //   useEffect(() => {
  //     const filteredItems = data?.data?.filter((item) =>
  //       item.name.toLowerCase().includes(search.toLowerCase())
  //     );
  //     setFilteredData(filteredItems);
  //   }, [search, data]);

  return (
    <>
      <div className="row admindashboard mt-3">
        {data?.length > 0 ?
          data.map((item, index) => {
            if (search.length && !item.name.toLowerCase().includes(search.toLowerCase())) return null;
            return (
              <React.Fragment key={index}>
                <div className="col-xxl-2- col-xl-2 col-lg-3 col-md-4 col-sm-6 px-2">
                  <Link to={`/dashboard/${item.uuid}`}>
                    <div className="usercard groupcard">
                      <div className="userdata">
                        {item.avatar ? (
                          <div className="grouplogo">
                            <img src={item.avatar} alt="" />
                          </div>
                        ) : (
                          <div className='initials-placeholder'>
                            {item?.name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                          </div>
                        )}
                        <div className="groupdata">
                          <p>{item.name}</p>
                          <p>
                            <span>{item.groups} Groups</span>
                            <span>{item.users} Users</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </React.Fragment>
            )
          })
          :
          <>
            <div className="no-data-found text-center mt-2">
              <div className="textdata">
                <LottiePlayer animationData={NoDataFound} style={{ height: 150, marginBottom: 0 }} />
                <h5 style={{ marginTop: '-10px' }}>No Sub-Groups Found</h5>
              </div>
            </div>
          </>
        }
      </div>
    </>
  );
};

export default GroupCard;
